module.exports = __webpack_public_path__ + "static/media/gender-female-deceased.9cde064a.png";